import Module, { convertToGrams, convertToInput, convertToPound, convertToKG } from './weightInput.js'
export default Module
export { convertToGrams, convertToInput, convertToPound, convertToKG }
